<template>
    <div class="datasearch-container">
        <div class="detail-header">
            <div class="title-box" style="display: flex; justify-content: space-between;">
                <h2>交易详情</h2>
                <h2 style="color: #8C9198; margin-left: 10px;margin-right: 10px;">/</h2>
                <h2 @click="switchTab" style="color: #8C9198; cursor: pointer;">图表</h2>
            </div>

            <div class="search-input-wrapper" v-show="false">
                <input type="text" placeholder="请输入地址/交易哈希/区块高度进行搜索" v-model="searchQuery" />
                <Search class="search-icon" @click="handleSearch" theme="outline" size="20" fill="#8c9198" />
            </div>
        </div>

        <div class="detail-content">
            <div class="left-box" style="width: 50%;height: 100%;">
                <div class="detail-card">
                    <h3>商品信息</h3>
                    <div class="detail-item">
                        <span class="item-label">商品ID</span>
                        <span class="item-value">{{ searchData?.asset_info?.asset_id || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">发行时间</span>
                        <span class="item-value">{{
                            searchData?.asset_info?.ctime ?
                                new Date(Number(searchData.asset_info.ctime) * 1000).toLocaleDateString('zh-CN', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit'
                                }) : '--'
                            }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">发行平台</span>
                        <span class="item-value">华艺链</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">发行量</span>
                        <span class="item-value">{{ searchData?.asset_info?.amount || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">流通量</span>
                        <span class="item-value">{{ searchData?.asset_info?.supply || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">发行状态</span>
                        <span class="item-value">
                            <span class="status-dot success"></span> {{ searchData?.asset_info?.status === 4 ? '发行成功' : '未发行'}}
                        </span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">创作者</span>
                        <span class="item-value">{{ searchData?.asset_info?.create_addr || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">商品名称</span>
                        <span class="item-value">{{ searchData?.asset_info?.title || '--' }}</span>
                    </div>
                </div>

                <div class="detail-card">
                    <h3>交易信息</h3>
                    <div class="detail-item">
                        <span class="item-label">交易哈希</span>
                        <span class="item-value">{{ searchData?.tx_info?.hx || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">交易时间</span>
                        <span class="item-value">{{
                            searchData?.tx_info?.[0]?.ctime ?
                                new Date(Number(searchData.tx_info[0].ctime) * 1000).toLocaleDateString('zh-CN', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit'
                                }) : '--'
                            }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">商品ID</span>
                        <span class="item-value">{{ searchData?.tx_info?.[0]?.asset_id || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">子ID</span>
                        <span class="item-value">{{ searchData?.tx_info?.[0]?.sub_id || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">发行方</span>
                        <span class="item-value">{{ searchData?.tx_info?.[0]?.from || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="item-label">接收方</span>
                        <span class="item-value">{{ searchData?.tx_info?.[0]?.to || '--' }}</span>
                    </div>
                </div>

            </div>

            <div class="right-box" ref="rightBox"
                style=" display: flex; justify-content: center; align-items: center; width:  50%;height: 100%; overflow: hidden;">
                <img :src="searchData?.url || ''" alt="商品图片" v-if="searchData?.url">
            </div>
        </div>
    </div>
</template>

<script>
import { Search } from '@icon-park/vue'

// Canvas水印实现方法
function addWatermark(container, options = {}) {
    const {
        text = '水印',
        fontSize = 12,
        color = 'rgba(0, 0, 0, 0.1)', // 提高透明度以便测试
        angle = -45,
        spacing = 150
    } = options;

    // 确保容器有正确的位置设置
    container.style.position = 'relative';

    // 创建canvas元素
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // 设置canvas尺寸（使用容器的offsetWidth和offsetHeight确保获取实际尺寸）
    canvas.width = container.offsetWidth;
    canvas.height = container.offsetHeight;

    // 确保canvas有内容尺寸
    if (canvas.width === 0 || canvas.height === 0) {
        // 如果容器还没有尺寸，使用默认尺寸
        canvas.width = 500;
        canvas.height = 500;
    }

    // 设置水印样式
    ctx.font = `${fontSize}px 微软雅黑`;
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // 计算水印旋转角度（弧度）
    const radian = (angle * Math.PI) / 180;

    // 绘制重复水印
    for (let y = 0; y < canvas.height; y += spacing) {
        for (let x = 0; x < canvas.width; x += spacing) {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(radian);
            ctx.fillText(text, 0, 0);
            ctx.restore();
        }
    }

    // 创建水印覆盖层
    const watermarkLayer = document.createElement('div');
    watermarkLayer.style.position = 'absolute';
    watermarkLayer.style.top = '0';
    watermarkLayer.style.left = '0';
    watermarkLayer.style.width = '100%';
    watermarkLayer.style.height = '100%';
    watermarkLayer.style.pointerEvents = 'none';
    watermarkLayer.style.backgroundImage = `url(${canvas.toDataURL()})`;
    watermarkLayer.style.backgroundSize = 'cover'; // 全覆盖
    watermarkLayer.style.zIndex = '9999'; // 确保显示在最上层

    // 添加水印到容器
    container.appendChild(watermarkLayer);

    return watermarkLayer;
}

export default {
    name: 'DataSearch',
    props: {
        searchData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        Search
    },
    data () {
        return {
            searchQuery: ''
        }
    },
    mounted () {
        console.log('mounted searchData:', this.searchData)
        // 使用setTimeout确保DOM已完全渲染
        setTimeout(() => {
            // 使用Canvas方法添加水印到rightBox容器
            if (this.$refs.rightBox) {
                addWatermark(this.$refs.rightBox, {
                    text: '华艺元界',
                    fontSize: 16,
                    color: 'rgba(0, 0, 0, 0.2)', // 提高透明度以便测试
                    angle: -45,
                    spacing: 150
                });
                console.log('水印已添加');
            } else {
                console.error('未找到rightBox容器');
            }
        }, 100);
    },
    watch: {
        searchData: {
            handler (newVal) {
                console.log('searchData changed:', newVal)
                if (newVal && Object.keys(newVal).length > 0) {
                    // 当searchData有值时可以执行其他逻辑
                }
            },
            deep: true
        }
    },
    methods: {
        handleSearch () {
            if (this.searchQuery.trim()) {
                // 这里可以添加搜索逻辑
                console.log('搜索:', this.searchQuery)
                // 可以根据搜索结果更新页面数据
            }
        },
        switchTab () {
            this.$emit('show-charts')
        }
    }
}
</script>

<style lang="less" scoped>
.datasearch-container {
    padding: 20px;
    padding-top: 80px;
    max-width: 1600px;
    margin: 0 auto;
    box-sizing: border-box;
}

.detail-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    overflow: hidden;
    flex-wrap: wrap;
}

.detail-header h2 {
    color: #ff6b6b;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
}

.search-input-wrapper {
    position: relative;
    width: 400px;
    max-width: 100%;
}

.search-input-wrapper input {
    width: 100%;
    padding: 10px 15px;
    padding-right: 40px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
}

.search-input-wrapper input:focus {
    border-color: #ff6b6b;
}

.search-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
}

.detail-content {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 76.5vh;
    box-sizing: border-box;

    .right-box {
        width: 50%;
        background-color: #ffffff;
        background-image: url('https://hyyjs.oss-cn-beijing.aliyuncs.com/miniApp/shanshuihua.png');
        background-size: cover;
        background-position: center;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        margin-left: 20px;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            z-index: 6;
            position: relative;
        }
    }
}

.detail-card {
    width: 100%;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
    box-sizing: border-box;
}

.detail-card h3 {
    color: #333;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;
}

.detail-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;
}

.detail-item:last-child {
    border-bottom: none;
}

.item-label {
    text-indent: 1rem;
    text-align: start;
    color: #666;
    font-size: 14px;
    font-weight: 600;
    width: 100px;
}

.item-value {
    color: #333;
    font-size: 14px;
    word-break: break-all;
    text-align: right;
}

.status-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;
    vertical-align: middle;
}

.status-dot.success {
    background-color: #52c41a;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .detail-content {
        grid-template-columns: 1fr;
        height: 100vh;
    }

    .detail-header {
        width: 100%;
        overflow: hidden;
    }

    .search-input-wrapper {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .datasearch-container {
        padding: 15px;
    }

    .detail-card {
        padding: 20px;
    }

    .detail-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .item-value {
        text-align: center;
    }
}
</style>